__webpack_require__.p = "/views-board/onboarding/";